import React, { useEffect, useRef, useState } from 'react';
import './VerifyOtpModal.less';
import { Button, Modal, Divider, InputNumber, notification } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { getVerifyOTP } from '@Src/apiServices/OrganisationProfileService';
import { getCompanyId } from '@Src/commons/Utils/authUtils';
import {
  getCompanyIdentifierId,
  getOTP,
  verifyOTP,
} from '@Src/components/OrganisationProfile/OrganisationProfileAction';
import OtpInput from 'react-otp-input';
import {
  TypeRequestOtp,
  TypeVerifyOtp,
} from '@Src/components/OrganisationProfile/Type';
import { StyledDivider, NormalText } from '@Src/commons/StyledComponent';
import COLOR from '@Src/commons/Colors';
import { getFDsErrorMessageFromError } from '@Src/commons/Utils';
import { ShowNormalError } from '@Src/commons/Notifications/Errors';

function VerifyOtpModal({
  verifyOtpModalOpen,
  setVerifyOtpModalOpen,
  gstin,
  companyIdentifierId,
  requestId,
  setRequestId,
  setInputList,
  inputList,
  username,
  setVerificationPending,
}) {
  const [reSendOtp, setReSendOtp] = useState(false);
  const [otp, setOtp] = useState();
  const [statusCode, setStatusCode] = useState(0);
  const [incorrectOtp, setIncorrectOtp] = useState(false);

  const { GRAY_9, RED_2, GREEN, ERROR_RED, RED_08, GRAY_5 } = COLOR;

  const reSendOTPInput = () => {
    setOtp();
    const data: TypeRequestOtp = {
      username,
      companyId: Number(getCompanyId()),
      gstin,
      companyIdentifierId,
    };
    getOTP(data)
      .then((res) => {
        setRequestId(res?.data?.requestId);
      })
      .catch((err) => {
        if (err?.message?.error) {
          ShowNormalError({
            text: err?.message?.error,
            buttonProp: null,
          });
        }
      });
    setReSendOtp(false);
    setIncorrectOtp(false);
  };

  const verifyOTPInput = () => {
    const requestBody: TypeVerifyOtp = {
      requestId,
      otp,
      companyId: Number(getCompanyId()),
      gstin,
      companyIdentifierId,
    };
    verifyOTP(requestBody)
      .then((res) => {
        setVerifyOtpModalOpen(false);
        setVerificationPending(false);
        setInputList((inputList: any[]) =>
          inputList.map((inputItem) => {
            if (inputItem.gstin === gstin) {
              return { ...inputItem, isReportSyncing: true };
            }
            return inputItem;
          })
        );
        notification.success({
          message: 'GSTR Reports Fetched Successfully',
          description:
            'We have successfully been able to fetch the required reports.',
          icon: (
            <CheckCircleOutlined
              style={{ color: `${GREEN}`, fontSize: '20px' }}
            />
          ),
        });
      })
      .catch((err) => {
        setIncorrectOtp(true);
        notification.error({
          message: 'OTP Verification Unsuccessful',
          description:
            'There was an error validating the OTP. Please try again or upload manually or try again after sometime.',
          icon: (
            <CloseCircleOutlined
              style={{ color: `${RED_2}`, fontSize: '20px' }}
            />
          ),
        });
      });
  };

  function Heading() {
    return (
      <div className="verify-otp-modal-header">
        <div>Verify OTP</div>
        <CloseOutlined onClick={() => setVerifyOtpModalOpen(false)} />
      </div>
    );
  }
  const handleCancel = () => {
    setVerifyOtpModalOpen(false);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setReSendOtp(true);
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div>
      <Modal
        className="verify-otp-modal"
        open={verifyOtpModalOpen}
        title={Heading()}
        width="400px"
        footer={null}
        closable={false}
        onCancel={handleCancel}
      >
        <div className="p-16 h-gap-12">
          <NormalText fontSize={14} color={COLOR.GRAY_9} fontWeight={400}>
            An OTP has been sent to the mobile number linked to this GSTIN
          </NormalText>
          <div className="otp-input">
            <div>OTP</div>
            <div className="verify-otp-div-wrapper">
              <OtpInput
                containerStyle={{ display: 'flex', gap: '4px' }}
                inputStyle={{
                  height: '32px',
                  width: '30px',
                  borderRadius: '4px',
                  border: `1px solid ${
                    incorrectOtp ? `${COLOR.RED_08}` : `${COLOR.GRAY_5}`
                  }`,
                }}
                value={otp}
                onChange={(e) => {
                  setOtp(e);
                  setIncorrectOtp(false);
                }}
                numInputs={6}
                inputType="tel"
                renderSeparator={<span> </span>}
                renderInput={(props) => <input {...props} />}
              />
            </div>
          </div>
          {reSendOtp || incorrectOtp ? (
            <div className="v-gap-3 mt--8" style={{ minHeight: '20px' }}>
              <p
                className="otp-text"
                style={{ color: incorrectOtp ? `${COLOR.ERROR_RED}` : '' }}
              >{`${
                incorrectOtp
                  ? 'OTP entered is incorrect.'
                  : 'Didn’t receive an OTP?'
              }`}</p>
              <div
                className="resend-otp"
                onClick={() => {
                  reSendOTPInput();
                }}
              >
                Click here to resend
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
        <StyledDivider />
        <div className="modal-footer">
          <div>
            <Button
              type="primary"
              disabled={otp?.length !== 6 ? true : !!incorrectOtp}
              onClick={() => verifyOTPInput()}
            >
              Verify
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
export default VerifyOtpModal;
